<template>
  <div class="content-box">
    <section class="photoLable-box">
      <PhotoLabel :origin="'meinv'" :labels="model.topLabel" />
    </section>
    <section class="list-box">
      <Gallery v-for="(item, index) in model.list" :source="'Model'" :gallery="item" :key="index" />
    </section>
    <Pagination
      :total="model.total"
      v-on:curPageChange="updatePage"/>
    <section>
      <Title :title="'热门美女标签'" />
      <article class="tag-list">
        <Tag v-for="(item, index) in model.bottomLabel" :origin="'meinv'" :label="item" :key="index"/>
      </article>
    </section>
  </div>
</template>

<script>
  import Gallery from '@/components/GalleryM'
  import Pagination from '@/components/Pagination'
  import PhotoLabel from '@/components/PhotoLabel'
  import Tag from '@/components/Tag'
  import Title from '@/components/TitleM'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      Gallery,
      Pagination,
      PhotoLabel,
      Tag,
      Title
    },

    // 服务器端渲染，预加载数据
    asyncData ({ store, route }) {
      const pageParams = route.params;
      const pinyin = pageParams.pinyin || pageParams.parent;
      const page = pageParams.page ? pageParams.page.match(/\d+/g)[0] : 1;
      store.state.params.variables.page = page;
      if (!pinyin) {
        // 获取未分类的 model 页面数据
        return store.dispatch('getModelList');
      } else {
          // 通过labelId 获取 model 页面数据
          return store.dispatch('getModeListByLabel', { pinyin: pinyin });
      }
    },
    computed: {
      ...mapGetters({
        model: 'modelData'
      })
    },
    created () {

    },
    methods: {
      // 分页组件点击事件
      updatePage (page) {
        const pageParams = this.$route.params;
        const path = this.$route.fullPath;

        if (pageParams.page) {
          let pathAry = path.split('/');
          pathAry.pop();
          window.location.href = `${ pathAry.join('/') }/p-${ page }.html`;
        } else {
          window.location.href = `${ path }p-${ page }.html`
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .content-box {
    padding-top: px2rem(58px);
  }
  .photoLable-box {
    box-sizing: border-box;
    position: fixed;
    top: px2rem(45px);
    width: 100%;
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Model.vue